import * as React from 'react';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { NameTuneCardComponent } from '../nametunecardcomponent';
import { NameTuneCardCSSStyleImpl } from '../nametunecardcss';
import { NameTuneEvenCardCSSStyleImpl } from '../nametuneevencardcss';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { ToneCardCSSStyle } from '../../../home/featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { ToneRowOptionsPrivilage, ToneRowOptionsPrivilageImpl } from '../../../../toolkit/toneoptions/tone/tonerowcomponent';
import { SearchListToneCardPlayerCSSStyleImpl } from '../../../home/searchlist/searchlisttonecardplayercss';
import { ToneCardPlayerCSSStyleImpl } from '../../../home/featuredcategory/viewmodel/tonecard/tonecardplayercss';
import { ToneMobileCardPlayerCSSStyleImpl } from '../../../home/featuredcategory/viewmodel/tonecard/tonemobilecardplayercss';
import { GridPaginationListViewModelImpl } from '../../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel';


export class NameTunesToneRowOptionsImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setLike(true);
        this.setGift(false);
        this.setShare(true);
        this.setBuy(true);
        this.setDelete(false);
        this.setTellAFriend(true);
        this.setAddWishList(true);
        this.setPlay(true);
        this.setSettings(false);
        this.setAction(true);
    }
}
export class NameTuneListViewModelImpl extends GridPaginationListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    // private searchKey: string;
    private playerWithProgress: AudioPlayerWithProgress;
    private toneRowPrivilage: ToneRowOptionsPrivilage;
    private playerCSSStyle1: SearchListToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle: ToneCardPlayerCSSStyleImpl;

    constructor(offset: string, context: BaseContext, private marginTop1: string)
    {
        super(offset, context);
        this.toneOddCardCSSStyle = new NameTuneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new NameTuneEvenCardCSSStyleImpl(context);
        this.toneRowPrivilage = new NameTunesToneRowOptionsImpl();
        this.playerCSSStyle1 = new SearchListToneCardPlayerCSSStyleImpl(context);
        this.playerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());

        this.playerMobileCSSStyle = new ToneMobileCardPlayerCSSStyleImpl(context);
    }

    // setSearchKey(searchKey: string)
    // {
    //     this.searchKey = searchKey;
    // }

    // getHeader(): boolean | JSX.Element {

    //     return <h2 style={this.getTitleCSSStyle()}>{"Results For "+ this.searchKey}</h2>;
    // }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        console.log("------nametunes");
        if(position % 2 === 0)
        {
            return <NameTuneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle1} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.toneRowPrivilage} marginTop={this.marginTop1} audioPlayerWithProgress={this.playerWithProgress} cardStyle={this.toneOddCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <NameTuneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle1} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.toneRowPrivilage} marginTop={this.marginTop1} audioPlayerWithProgress={this.playerWithProgress} cardStyle={this.toneEvenCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

    onToneSelected():void
    {
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunecard/viewmodel/nametunelistviewmodel.tsx